import { FormikProps } from "formik";
import Flex from "../../../../../../../components/Flex";
import MicroTextArea from "../../../../../../../components/MicroTextArea";
import CustomTitle from "../../../../../../../components/app/CustomTitle";
import { VisitNoteFormValues } from "../VisitNoteTemplateForm";
import CustomTextArea from "../../../../../../../components/CustomTextArea";

interface PsychiatricNoteFormProps {
  formik: FormikProps<VisitNoteFormValues>;
  readOnly?: boolean;
}

export const PsychiatricNoteForm = ({
  formik,
  readOnly,
}: PsychiatricNoteFormProps) => {
  return (
    <Flex flexDirection="column" gap={2} p={1} width={"100%"}>
      <MicroTextArea
        disabled={readOnly}
        label="Subjective"
        rows={4}
        variant="outlined"
        name="subjectiveFreeNote"
        placeholder="Enter subjective notes..."
        value={formik.values.subjectiveFreeNote}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      <CustomTextArea
        disabled={readOnly}
        label="Allergy"
        id="outlined-multiline-static"
        rows={3}
        variant="outlined"
        name="allergyFreeText"
        placeholder="Enter Allergies, ex:dust <press enter> food <press enter> animal dander ...etc"
        onBlur={formik.handleBlur}
        value={formik.values?.allergyFreeText}
        onChange={formik.handleChange}
      />

      <MicroTextArea
        disabled={readOnly}
        label="History of Present Illness (HPI)"
        rows={4}
        variant="outlined"
        name="hpi"
        placeholder="Enter HPI..."
        value={formik.values.hpi}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      <MicroTextArea
        disabled={readOnly}
        label="Problems"
        rows={4}
        variant="outlined"
        name="problems"
        placeholder="Enter problems..."
        value={formik.values.problems}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      <MicroTextArea
        disabled={readOnly}
        label="Habits"
        rows={4}
        variant="outlined"
        name="habits"
        placeholder="Enter habits..."
        value={formik.values.habits}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      <MicroTextArea
        disabled={readOnly}
        label="Objective"
        rows={4}
        variant="outlined"
        name="objectiveFreeNote"
        placeholder="Enter objective notes..."
        value={formik.values.objectiveFreeNote}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      {/* Assessment */}
      <MicroTextArea
        disabled={readOnly}
        label="Assessment"
        rows={4}
        variant="outlined"
        name="assessmentFreeNote"
        placeholder="Enter assessment..."
        value={formik.values.assessmentFreeNote}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      {/* Plan */}
      <MicroTextArea
        disabled={readOnly}
        label="Plan"
        rows={4}
        variant="outlined"
        name="planFreeNote"
        placeholder="Enter plan..."
        value={formik.values.planFreeNote}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      {/* Care Plan */}
      <MicroTextArea
        disabled={readOnly}
        label="Care Plan"
        rows={4}
        variant="outlined"
        name="carePlan"
        placeholder="Enter care plan..."
        value={formik.values.carePlan}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      {/* Instructions */}
      <MicroTextArea
        disabled={readOnly}
        label="Instructions"
        rows={4}
        variant="outlined"
        name="instruction"
        placeholder="Enter instructions..."
        value={formik.values.instruction}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      {/* Follow Up */}
      <Flex flexDirection="column" gap={1}>
        <CustomTitle>Follow Up</CustomTitle>
        <MicroTextArea
          disabled={readOnly}
          rows={4}
          variant="outlined"
          name="followUp"
          placeholder="Enter follow up instructions..."
          value={formik.values.followUp}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Flex>
    </Flex>
  );
};
